import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "input" }
const _hoisted_2 = ["name", "id", "checked", "required", "disabled", "value"]
const _hoisted_3 = {
  key: 0,
  class: "text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass({ isRequired: _ctx.required, isDisabled: _ctx.disabled })
    }, [
      _createElementVNode("input", {
        type: "radio",
        name: _ctx.inputName,
        id: _ctx.inputId,
        onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isFocused = true)),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isFocused = false)),
        onChange: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$emit('update:modelValue', $event.target.value); _ctx.$emit('change', $event.target.value)}),
        checked: _ctx.modelValue === _ctx.value,
        required: _ctx.required,
        disabled: _ctx.disabled,
        value: _ctx.value
      }, null, 40, _hoisted_2),
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "mimicry" }, null, -1)),
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}